import { IApiResponse } from "@/interface";
import { axios } from "@/lib/axios"


export const  apiLogin = ( data:any ):Promise<IApiResponse> => {
    return axios.post('/login',data);
}

export const  apiResetPasswordSendMail = ( data:any ):Promise<IApiResponse> => {
    return axios.post('/reset-password',data);
}

export const  apiResetPasswordByUserId = (endPoint:string,data:any ):Promise<IApiResponse> => {
    return axios.put(endPoint,data);
}